import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function UploadProfileImgModal({
  cancelModal,
  fetchData,
  reviewPendingClub,
}) {
  const [selectedFile, setSelectedFile] = useState(null);

  const { user } = useAuthContext();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //styled
  const handleFileChange = (e) => {
    setIsLoading(true);
    try {
      const file = e.target.files[0];
      setSelectedFile(file);
      if (file) {
        setPreviewUrl(URL.createObjectURL(file)); // Create a preview URL for the selected image
      } else {
        setPreviewUrl(null);
      }
    } catch (error) {
      console.error("Error handling file change:", error);
    } finally {
      setIsLoading(false); // Ensure loading state is reset
    }
  };
  
  const fileUploadHandler = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    if (!selectedFile) return; // Don't proceed if no file selected

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/pendingclub/profile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status == 200) {
        fetchData();
        reviewPendingClub();
        setUploadSuccess(true);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (uploadSuccess) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Image Uploaded</p>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The profile image has been successfully uploaded.</p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div>
              {" "}
              {/* Attach submit handler */}
              <div className="send-modal-content">
                <div className="blueBanner">
                  <p className="fw-bold m-2 p-2 fontSize20">Upload Image</p>
                </div>
                <button
                  type="button"
                  className="close-button"
                  onClick={cancelModal}
                  aria-label="Close"
                >
                  &times;
                </button>
                <div>
                  <input type="file" onChange={handleFileChange} />
                  <button
                    className="saveChanges-button"
                    onClick={fileUploadHandler}
                    type="submit"
                  >
                    Upload
                  </button>
                </div>
                {previewUrl && (
                  <img
                    src={previewUrl}
                    alt="Image Preview"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
              <div className="send-modal-footer">
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
